module.exports = __webpack_public_path__ + "img/solution19.e159aed7.png";